import React from 'react';
import { Link } from 'react-router-dom';
import ProjectItem from '../../../../components/ProjectItem/ProjectItem';

const ProjectsArea = () => {
   return (
      <>
         <div className="tp-prjects-area pt-120 pb-120">
            <div className="container">
               {false && (<div className="row">
                  <div className="col-12">
                     <div className="tp-prjects-tab-menu mb-60">
                        <ul className="nav justify-content-center" id="myTab" role="tablist">
                           <li className="nav-item" role="presentation">
                              <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">All</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Carpet</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Glass</button>
                           </li>

                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab1" data-bs-toggle="tab" data-bs-target="#contact1" type="button" role="tab" aria-controls="contact1" aria-selected="false">Outdoor</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab2" data-bs-toggle="tab" data-bs-target="#contact2" type="button" role="tab" aria-controls="contact2" aria-selected="false">Office</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab3" data-bs-toggle="tab" data-bs-target="#contact3" type="button" role="tab" aria-controls="contact3" aria-selected="false">Kitchen</button>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>)}
               <div className="row pb-50">
                  <div className="col-12">
                     <div className="tp-prjects-tab-content">
                        <div className="tab-content" id="myTabContent">
                           <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                              <div className="row">

                                 <ProjectItem project_img_num="1" project_subtitle="Public Service"
                                    project_title="Nettoyage de ville"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Commercial Service"
                                    project_title="Nettoyage de supermarchés"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Private Service"
                                    project_title="Nettoyage des hotels"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Home Service"
                                    project_title="Nettoyage residentiel"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Social Service"
                                    project_title="River cleanup Young"></ProjectItem>
 

                              </div>
                           </div>

                           <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div className="row">

                                 <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage de vitres"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage Expert de Votre Cuisine"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage Extérieur"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage de salle de bain"></ProjectItem>

                                 <ProjectItem project_img_num="9" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage d'appartement"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage des sols"></ProjectItem> 

                                 <ProjectItem project_img_num="7" project_subtitle="Residentiel Service"
                                    project_title="Nettoyage du marché"></ProjectItem>

                                 <ProjectItem project_img_num="8" project_subtitle="Residentiel Service"
                                    project_title="Service de plomberie"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                              <div className="row">

                              <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de vitres"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Expert de Votre Cuisine"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Extérieur"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de salle de bain"></ProjectItem>

                                 <ProjectItem project_img_num="9" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage d'appartement"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage des sols"></ProjectItem>

                                 <ProjectItem project_img_num="6" project_subtitle="Residentiel Service"
                                 project_title="Ground Cleaning"></ProjectItem>

                                 <ProjectItem project_img_num="7" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage du marché"></ProjectItem>

                                 <ProjectItem project_img_num="8" project_subtitle="Residentiel Service"
                                 project_title="Service de plomberie"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1">
                              <div className="row">
                                 <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de vitres"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Expert de Votre Cuisine"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Extérieur"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de salle de bain"></ProjectItem>

                                 <ProjectItem project_img_num="9" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage d'appartement"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage des sols"></ProjectItem>

                                 <ProjectItem project_img_num="6" project_subtitle="Residentiel Service"
                                 project_title="Ground Cleaning"></ProjectItem>

                                 <ProjectItem project_img_num="7" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage du marché"></ProjectItem>

                                 <ProjectItem project_img_num="8" project_subtitle="Residentiel Service"
                                 project_title="Service de plomberie"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact2" role="tabpanel" aria-labelledby="contact-tab2">
                              <div className="row">
                                <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de vitres"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Expert de Votre Cuisine"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Extérieur"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de salle de bain"></ProjectItem>

                                 <ProjectItem project_img_num="9" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage d'appartement"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage des sols"></ProjectItem>

                                 <ProjectItem project_img_num="6" project_subtitle="Residentiel Service"
                                 project_title="Ground Cleaning"></ProjectItem>

                                 <ProjectItem project_img_num="7" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage du marché"></ProjectItem>

                                 <ProjectItem project_img_num="8" project_subtitle="Residentiel Service"
                                 project_title="Service de plomberie"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact3" role="tabpanel" aria-labelledby="contact-tab3">
                              <div className="row">
                                 <ProjectItem project_img_num="1" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de vitres"></ProjectItem>

                                 <ProjectItem project_img_num="2" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Expert de Votre Cuisine"></ProjectItem>

                                 <ProjectItem project_img_num="3" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage Extérieur"></ProjectItem>

                                 <ProjectItem project_img_num="4" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage de salle de bain"></ProjectItem>

                                 <ProjectItem project_img_num="9" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage d'appartement"></ProjectItem>

                                 <ProjectItem project_img_num="5" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage des sols"></ProjectItem>

                                 <ProjectItem project_img_num="6" project_subtitle="Residentiel Service"
                                 project_title="Ground Cleaning"></ProjectItem>

                                 <ProjectItem project_img_num="7" project_subtitle="Residentiel Service"
                                 project_title="Nettoyage du marché"></ProjectItem>

                                 <ProjectItem project_img_num="8" project_subtitle="Residentiel Service"
                                 project_title="Service de plomberie"></ProjectItem>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div> 
            </div>
         </div>
      </>
   );
};

export default ProjectsArea;